import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ScreenShareOff = createReactComponent("ScreenShareOff", ["svg", defaultAttributes, [["path", {
  d: "M13 3H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2v-3",
  key: "9s0k9s"
}], ["path", {
  d: "M8 21h8",
  key: "62csdj"
}], ["path", {
  d: "M12 17v4",
  key: "icnn2j"
}], ["path", {
  d: "M22 3l-5 5",
  key: "xzltjy"
}], ["path", {
  d: "M17 3l5 5",
  key: "125xta"
}]]]);
export default ScreenShareOff;